import CustomButton from "components/button";
import { DynamicOption } from "components/fields/SelectInput";
import { DeviceObj } from "views/counters";
import { ProjectObject } from "views/projects";
import { TypeObject } from "views/settings/DeviceTypesTable";
import { EventType } from "views/settings/EventTypesTable";
import { ModuleTypeObject } from "views/settings/ModuleTypesTable";
import { PermissionObj } from "views/settings/Permissions";
import { PermissionCategory } from "views/settings/PermissionsCategory";
import { AdminsObject } from "views/users/AdminsTable";
import { UserObject } from "views/users/UsersTable";
import { ModuleObject } from "views/warehouse/ModuleStorage";

interface DeleteFormProps {
  deleteType:
    | "project"
    | "user"
    | "admin"
    | "simpleCounter"
    | "module"
    | "event"
    | "consumptions"
    | "eventType"
    | "moduleType"
    | "permissions"
    | "permissionsCategory"
    | "deviceType"; // ✅ NEW
  projectDeleted?: ProjectObject;
  userDeleted?: UserObject;
  adminDeleted?: AdminsObject;
  simpleCounterDeleted?: DeviceObj;
  moduleDeleted?: ModuleObject;
  counterConsuptionDeleted?: DynamicOption;
  eventTypeDeleted?: EventType;
  moduleTypeDeleted?: ModuleTypeObject;
  permissionsDeleted?: PermissionObj;
  permissionsCategoryDeleted?: PermissionCategory;
  deviceTypeDeleted?: TypeObject; // ✅ NEW
  onClose: Function;
  deleteFunction: Function;
}
const DeleteForm = (props: DeleteFormProps) => {
  const {
    onClose,
    deleteFunction,
    projectDeleted,
    userDeleted,
    adminDeleted,
    simpleCounterDeleted,
    moduleDeleted,
    deleteType,
    counterConsuptionDeleted,
    eventTypeDeleted,
    moduleTypeDeleted,
    permissionsDeleted,
    permissionsCategoryDeleted,
    deviceTypeDeleted, // ✅ NEW
  } = props;

  return (
    <div className=" flex flex-col space-y-4 font-bold">
      <div className="">
        {" "}
        {`شما در حال حذف ${
          deleteType === "project"
            ? "پروژه"
            : deleteType === "admin"
            ? "کاربر سیستم"
            : deleteType === "user"
            ? "بهره بردار"
            : deleteType === "simpleCounter"
            ? "کنتور مکانیکی"
            : deleteType === "module"
            ? "ماژول"
            : deleteType === "event"
            ? "رخدادهای"
            : deleteType === "eventType"
            ? "نوع رخداد"
            : deleteType === "moduleType"
            ? "نوع ماژول"
            : deleteType === "permissions"
            ? "دسترسی"
            : deleteType === "permissionsCategory"
            ? "نقش"
            : deleteType === "deviceType" // ✅ NEW
            ? "نوع دستگاه"
            : "مقادیر مصرف"
        } "${
          deleteType === "project"
            ? projectDeleted.water_meter_project_name
            : deleteType === "user"
            ? `${userDeleted.user_name} ${userDeleted.user_lastname}`
            : deleteType === "admin"
            ? `${adminDeleted.admin_name} ${adminDeleted.admin_lastname}`
            : deleteType === "simpleCounter"
            ? `${simpleCounterDeleted.water_meter_name}`
            : deleteType === "module"
            ? `${moduleDeleted.water_meter_module_name}`
            : deleteType === "eventType"
            ? `${eventTypeDeleted.event_type_keyword}`
            : deleteType === "moduleType"
            ? `${moduleTypeDeleted.module_type_name}`
            : deleteType === "permissions"
            ? `${permissionsDeleted.permission_persian_name}`
            : deleteType === "permissionsCategory"
            ? `${permissionsCategoryDeleted.permission_category_persian_name}`
            : deleteType === "deviceType" // ✅ NEW
            ? `${deviceTypeDeleted?.water_meter_type_name}`
            : `${counterConsuptionDeleted.label}`
        }" هستید.`}
      </div>
      <div className="">در صورت حذف ، اطلاعات مربوطه قابل بازگشت نمی باشد.</div>
      <div className="">
        آیا از حذف{" "}
        {deleteType === "project"
          ? "پروژه"
          : deleteType === "admin"
          ? "کاربر سیستم"
          : deleteType === "user"
          ? "بهره بردار"
          : deleteType === "simpleCounter"
          ? "کنتور مکانیکی"
          : deleteType === "module"
          ? "ماژول"
          : deleteType === "event"
          ? "رخدادها"
          : deleteType === "eventType"
          ? "نوع رخداد"
          : deleteType === "moduleType"
          ? "نوع ماژول"
          : deleteType === "permissions"
          ? "دسترسی"
          : deleteType === "permissionsCategory"
          ? "نقش"
          : deleteType === "deviceType" // ✅ NEW
          ? "نوع دستگاه"
          : "مقادیر مصرف"}{" "}
        اطمینان دارید؟!{" "}
      </div>
      <div className="form-actions flex flex-row items-center justify-end ">
        <CustomButton onClick={onClose} text="بستن" color="blue" />
        <CustomButton
          onClick={() =>
            deleteFunction(
              deleteType === "project"
                ? projectDeleted.water_meter_project_id
                : deleteType === "user"
                ? userDeleted.user_id
                : deleteType === "admin"
                ? adminDeleted.admin_id
                : deleteType === "simpleCounter"
                ? simpleCounterDeleted.water_meter_serial
                : deleteType === "module"
                ? moduleDeleted.water_meter_module_id
                : deleteType === "eventType"
                ? eventTypeDeleted.event_type_id
                : deleteType === "moduleType"
                ? moduleTypeDeleted.module_type_id
                : deleteType === "permissions"
                ? permissionsDeleted.permission_id
                : deleteType === "permissionsCategory"
                ? permissionsCategoryDeleted.permission_category_id
                : deleteType === "deviceType" // ✅ NEW
                ? deviceTypeDeleted?.water_meter_type_id
                : counterConsuptionDeleted.value
            )
          }
          text={`حذف`}
          color="red"
          extra="!ml-0"
        />
      </div>
    </div>
  );
};
export default DeleteForm;
